import { HomeFloor2Icon } from './HomeFloor2Icon';

/**
 * author: GreenTurtwig
 * id FB09500A-A871-409C-B7D4-B18BDF0D8511
 * name home-floor-2
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-2.svg
 * tags
 * - Home Automation 
 */
export const HouseFloor2Icon = HomeFloor2Icon;
export default HouseFloor2Icon